<template>
  <div class="d-flex align-items-center justify-content-center">
    <div class="circle" :class="{ 'active': step===1 }">
      <font-awesome-icon :icon="['fas', 'building']" />
    </div>
    <div class="bd"></div>
    <div class="circle" :class="{ 'active': step===2 }">
      <img src="../../../assets/images/swipe-white.svg" height="24"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'stepper',
  props: ['step'],
  methods: {
    click (step) {
      this.$emit('select', step)
    }
  }
}
</script>
<style scoped>
  .circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #bdbdbd;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
  }

  .circle.active {
    background: linear-gradient(-135deg, #2e69af, #162e4a);
  }

  .bd {
    border-bottom: 1px solid #bdbdbd;
    width: 50px;
  }

  @media (max-width:480px) {

  }
</style>



// WEBPACK FOOTER //
// src/components/register/step-3/stepper.vue